/**
 * Quick View Modal for Easy.ge
 * Opens a modal with product details fetched via AJAX
 */
class QuickView extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.overlay = null;
  }

  connectedCallback() {
    this.addEventListener('click', this.open.bind(this));
  }

  async open(e) {
    e.preventDefault();
    e.stopPropagation();

    const handle = this.dataset.productHandle;
    if (!handle) return;

    this.createModal();
    this.showLoading();

    try {
      const response = await fetch(`/products/${handle}?section_id=quick-view-content`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const content = doc.querySelector('.quick-view-content');

      if (content) {
        this.modal.querySelector('.quick-view__body').innerHTML = content.innerHTML;
      }
    } catch (err) {
      this.modal.querySelector('.quick-view__body').innerHTML =
        '<p style="padding:40px;text-align:center;">შეცდომა. სცადეთ ხელახლა.</p>';
    }
  }

  createModal() {
    if (document.getElementById('quick-view-overlay')) {
      document.getElementById('quick-view-overlay').remove();
    }

    this.overlay = document.createElement('div');
    this.overlay.id = 'quick-view-overlay';
    this.overlay.className = 'qv-overlay';
    this.overlay.innerHTML = `
      <div class="qv-modal">
        <button class="qv-close" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="quick-view__body"></div>
      </div>
    `;

    document.body.appendChild(this.overlay);
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      this.overlay.classList.add('is-active');
    });

    this.overlay.querySelector('.qv-close').addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });

    document.addEventListener('keydown', this._escHandler = (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  showLoading() {
    this.overlay.querySelector('.quick-view__body').innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;min-height:300px;">
        <div class="qv-spinner"></div>
      </div>
    `;
  }

  close() {
    this.overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._escHandler);
    setTimeout(() => {
      this.overlay.remove();
    }, 300);
  }
}

customElements.define('quick-view', QuickView);
